import React, { useState } from "react";
import './TablaMonitoreoVistaProgramados.scss'
import { InputNumber } from "primereact/inputnumber";
import InputText from "../../atoms/InputText/InputText";
import Button from "../../atoms/Button/Button";
import ButtonGris from "../../atoms/ButtonGris/ButtonGris";
import { updatePagos } from "./TablaMonitoreoVistaProgramadosIntegracion";


const ModalCambioPrecio = ({precios,setOpenModal,id_bitacora,setDataModal,setModalInfo}) => {
    const [pagoChofer,setPagoChofer] = useState(precios.PAGO_CHOFER)
    const [pagoSubContratado,setPagoSubContratado] = useState(precios.PAGO_SUBCONTRATADO)
    const [precioCliente,setPrecioCliente] = useState(precios.PRECIO_CLIENTE)
    
    
    const editPagos = ()=>{
        const data = {
            pagoChofer:pagoChofer,
            pagoSubContratado:pagoSubContratado,
            precioCliente:precioCliente,
            id_bitacora:id_bitacora,
        }
        updatePagos(data,setDataModal,setOpenModal,setModalInfo)
    }
    return (
        <div className="ModalCambioPrecio">
            <div className="modalPrecioCard">
                <div className="inputs">
                    <InputText type="number" disabled={true} value={pagoChofer} title="Pago Chofer "></InputText>
                    <InputText type="number" value={pagoSubContratado} onChange={(e)=>{setPagoSubContratado(e.target.value)}} title="Pago Subcontratado"></InputText>
                    <InputText type="number"  disabled={true} value={precioCliente} title="PrecioCliente"></InputText>
                </div>
                <div className="buttons">
                    <Button onClick={()=>{editPagos()}}>Guardar</Button>
                    <ButtonGris onClick={()=>{setOpenModal(null)}}>cancelar</ButtonGris>
                </div>
            </div>
        </div>
    )
}
export default ModalCambioPrecio